import { useEffect, useRef } from 'react';
import { useDetailsPageContext } from 'marketplace-ui-common/context/DetailsPageContext';

interface UseCardViewTrackingProps {
  name: string;
}

export const useCardViewTracking = ({ name }: UseCardViewTrackingProps) => {
  const { trackInteraction } = useDetailsPageContext();
  const cardRef = useRef<HTMLDivElement>(null);
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!cardRef.current || hasTracked.current) {
      return;
    }

    const cardHeight = cardRef.current?.offsetHeight || 0;
    const windowHeight = window.innerHeight;
    const defaultThreshold = 0.75;
    const calculatedThreshold =
      cardHeight > windowHeight / defaultThreshold
        ? (windowHeight * defaultThreshold) / cardHeight
        : defaultThreshold;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasTracked.current) {
          trackInteraction({
            action: 'card viewed',
            section: name,
          });
          hasTracked.current = true;
          observer.disconnect();
        }
      },
      { threshold: calculatedThreshold }
    );

    observer.observe(cardRef.current);

    return () => observer.disconnect();
  }, [name, trackInteraction]);

  return cardRef;
};
